import { render, staticRenderFns } from "./detailsRight.vue?vue&type=template&id=32fb0912&"
import script from "./detailsRight.vue?vue&type=script&lang=js&"
export * from "./detailsRight.vue?vue&type=script&lang=js&"
import style0 from "./detailsRight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "detailsRight.vue"
export default component.exports